import {Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import {ExcCoreModule, ExcTranslation} from 'exc-core-v2';
import {ExcRestService, IExcDataFilter, IExcDataPaging, IExcDataSort} from 'exc-rest-v2';
import {IExcMetaInfo} from 'exc-rest-v2/lib/interfaces/IExcMetaInfo';
import {EnumerationService} from '../services/enumeration.service';
import {ApplicationService} from '../services/application.service';
import {ExgModalService} from 'exc-controls-v2';
import {ModalOeContactComponent} from './modals/modal-oe-contact.component';
import {ExgApplicationTab} from 'exc-tab-v2';
import {CalculationTemplateComponent} from '../Calculation/calculation-template/calculation-template.component';
import {QuestionnaireEditorComponent} from '../Questionnaire/questionnaire-editor/questionnaire-editor.component';
import {ExcSecurityService} from 'exc-security-v2';
import {NestedTreeControl} from '@angular/cdk/tree';
import {SelectionChange} from '@angular/cdk/collections';
import {ExgApplicationEventEmitter} from '../misc/classes/ExgApplicationEventEmitter';
import {FormularTemplateComponent} from '../formular/formular-template.component';

@Component({
  selector: 'app-oe-workspace',
  templateUrl: './oe-workspace.component.html',
  styles: [
  ]
})
export class OeWorkspaceComponent extends ExcTranslation implements OnInit {
  Events = new ExgApplicationEventEmitter();
  @Input()
  Data: { oeID: string; defaultOE: boolean; } = {
    oeID: '',
    defaultOE: false
  };
  @ViewChild('fileUpload') fileUpload!: ElementRef<HTMLInputElement>;

  @Input()
  tabinstance: any;

  oeSummary = {
    summary: {
      OEDetails: {} as any,
      OEDetailsClone: {} as any,
      MemberOf: [] as any[],
      Persons: [] as any[],
      Members: [] as any[],
      Groups: [] as any[],
      Addresses: [] as any[],
      Contacts: [] as any[],
      QuestionnaireConfig: [] as any[],
      CalculationConfig: [] as any[],
      FormularTemplate: [] as any[],
    },
    data: {} as any,
    oeData: [] as any[],
    state: 1,
    isLoading: true,
    MetaInfo: {
      dataPaging: {pageNo: 0, pageSize: 24} as IExcDataPaging,
      dataSort: {} as IExcDataSort,
      dataFilter: {} as IExcDataFilter,
      dataDistinct: {} as IExcDataFilter,
    } as IExcMetaInfo,
    ready: () => {
      this.oeSummary.isLoading = false;
    },
    loadDataObject: (incomingData: any): void => {
      this.oeSummary.data = incomingData;
      if (incomingData.OEDetails) {
        this.oeSummary.summary.OEDetails = incomingData.OEDetails;
        this.oeSummary.summary.OEDetailsClone = this.appSvc.helperObj.clone(incomingData.OEDetails);
      }

      if (incomingData.MemberOf) {
        this.oeSummary.summary.MemberOf = incomingData.MemberOf;
      }
      if (incomingData.Persons) {
        this.oeSummary.summary.Persons = incomingData.Persons;
      }
      if (incomingData.Members) {
        this.oeSummary.summary.Members = incomingData.Members;
      }
      if (incomingData.Groups) {
        this.oeSummary.summary.Groups = incomingData.Groups;
      }
      if (incomingData.Addresses) {
        this.oeSummary.summary.Addresses = incomingData.Addresses;
      }
      if (incomingData.Contacts) {
        this.oeSummary.summary.Contacts = incomingData.Contacts;
      }
      if (incomingData.QuestionnaireConfig) {
        this.oeSummary.summary.QuestionnaireConfig = incomingData.QuestionnaireConfig;
      }
      if (incomingData.CalculationConfig) {
        this.oeSummary.summary.CalculationConfig = incomingData.CalculationConfig;
      }
      if (incomingData.FormularTemplate) {
        this.oeSummary.summary.FormularTemplate = incomingData.FormularTemplate;
      }

      this.oeSummary.ready();
    },
    loadData: () => {
      const SELF = this;
      SELF.oeSummary.state = 1;
      SELF.oeSummary.isLoading = true;

      SELF.excRestService
        .get(
          SELF.excRestService.computeUrl('OESummary', {
            oeID: SELF.Data.oeID
          }), {
            MetaInfo: {
              dataPaging: this.oeSummary.MetaInfo.dataPaging,
              dataSort: this.oeSummary.MetaInfo.dataSort,
              dataFilter: this.oeSummary.MetaInfo.dataFilter
            }
          })
        .subscribe(
          (data: any) => {
            if (data.data) {
              SELF.oeSummary.loadDataObject(data.data);
            }
            if (SELF.init) {
              if (
                this.enumService.getEnumerationText(
                  this.oeSummary.summary.OEDetails.oe_enmName_OETyp,
                  this.oeSummary.summary.OEDetails.oe_enmIdent_OETyp
              ) === 'Person') {
                this.tabinstance.Label = this.oeSummary.summary.OEDetails?.oeName + ', ' + this.oeSummary.summary.OEDetails?.oeEName;
                this.tabinstance.Icon = 'fa-solid fa-user-tie';
              } else {
                this.tabinstance.Label = this.oeSummary.summary.OEDetails?.oeNPraefix;
                this.tabinstance.Icon = 'fa-regular fa-building';
              }
              if (this.Data.oeID === '00000000-0000-0000-0000-000000000000') {
                this.tabinstance.Label = 'Default OE';
              }
              this.init = false;
            }
          }
        );
    },
  };
  oeActions = [] as any[];
  memberActions = [] as any[];
  init = true;
  editMode = false;

  oeTypList = [] as any[];
  oeAnredeList = [] as any[];
  oeRolleList = [] as any[];

  allTemplates: any[] = [];
  ConfigTemplateTree = {
    treeControl: new NestedTreeControl<any>(node => node.children),
    dataSource: [] as any[],
    hasChild: (_: number, node: any) => node.is_directory === true
  };
  /** Map zum schnellen Restore: source -> Ordner-Node */
  private folderBySource = new Map<string, any>();
  isLoadingTemplates = true;
  AttachmentFolderStates: string[] = [];
  constructor(
    private modalSvc: ExgModalService,
    private excRestService: ExcRestService,
    public excSecurity: ExcSecurityService,
    public enumService: EnumerationService,
    public appSvc: ApplicationService
  ) {
    super();
  }
  // todo: isEditable(parameter existiert schon in der Metatabelle), Ordner visuell abheben?, i18n translation
  //  , Ordner Struktur auflassen nach CRUD, Update(file replace?), fileview und preview

  ngOnInit(): void {
    this.Events.OE.Summary.Reload.subscribe(() => {
      this.oeSummary.loadData();
    });
    this.loadAllTemplates();
    this.oeSummary.loadData();
    this.ConfigTemplateTree.dataSource = this.buildTree(this.allTemplates);
    this.oeActions = [
      {
        security: '*',
        get caption(): string {
          return 'Questionnaire';
        },
        get visible(): boolean {
          this._visible = ExcCoreModule.Services().ExcSecurityService.isFeatured(this.security);
          return true;
        },
        click: (): void => {
          this.openModalOeQuestionnaireComponent();
        }
      },
      {
        security: '*',
        get caption(): string {
          return 'Kalkulation';
        },
        get visible(): boolean {
          this._visible = ExcCoreModule.Services().ExcSecurityService.isFeatured(this.security);
          return true;
        },
        click: (): void => {
          this.openModalOeCalculationComponent();
        }
      },
      {
        security: '*',
        get caption(): string {
          return 'Kontakt';
        },
        get visible(): boolean {
          this._visible = ExcCoreModule.Services().ExcSecurityService.isFeatured(this.security);
          return true;
        },
        click: (): void => {
          this.openModalOeContactComponent();
        }
      },
      {
        security: '*',
        get caption(): string {
          return 'Adresse';
        },
        get visible(): boolean {
          this._visible = ExcCoreModule.Services().ExcSecurityService.isFeatured(this.security);
          return true;
        },
        click: (): void => {
          this.openModalOeAddressComponent();
        }
      },
    ];
    this.memberActions = [
      {
        security: '*',
        get caption(): string {
          return 'Organisationseinheit';
        },
        get visible(): boolean {
          this._visible = ExcCoreModule.Services().ExcSecurityService.isFeatured(this.security);
          return true;
        },
        click: (): void => {
          this.openModalOeList();
        }
      },
      {
        security: '*',
        get caption(): string {
          return 'Gruppe';
        },
        get visible(): boolean {
          this._visible = ExcCoreModule.Services().ExcSecurityService.isFeatured(this.security);
          return true;
        },
        click: (): void => {
          this.openModalGroupList();
        }
      },
    ];
    this.initLists();

    this.ConfigTemplateTree.treeControl.expansionModel.changed.subscribe((change: SelectionChange<any>) => {
      // Folders, die hinzugefügt wurden (geöffnet)
      for (const added of change.added ?? []) {
        if (added?.is_directory) {
          if (!this.AttachmentFolderStates.includes(added.stream_id)) {
            this.AttachmentFolderStates.push(added.stream_id);
          }
        }
      }

      // Folders, die entfernt wurden (geschlossen)
      for (const removed of change.removed ?? []) {
        if (removed?.is_directory) {
          this.AttachmentFolderStates = this.AttachmentFolderStates.filter(
            id => id !== removed.stream_id
          );
        }
      }
    });
  }


  onFileSelected(node: any): void {
    const i = document.getElementById('file-' + node.stream_id) as HTMLInputElement;

    if (i) {
      i.click();
    }
  }

  uploadTemplate(node: any, event: any): void {
    if (!node.rtmIsEditable && !this.Data.defaultOE) {
      return;
    }

    const files = event.target.files;
    if (!files || files.length === 0) {
      return;
    }

    const file = files[0];
    const formData = new FormData();

    formData.append('file', file, file.name);

    let url = this.excRestService.computeUrl('ReportTemplateC', {oeID: this.Data.oeID});
    if (node.path_locator_string) {
      url += '?parentPath=' + encodeURIComponent(node.path_locator_string);
    }

    this.excRestService.post(url, formData).subscribe(
      (response: any) => {
        if (response.success) {
          this.modalSvc.showToast(
            'Template hochgeladen',
            'md-toast bg-green',
            'far fa-check'
          );
          this.loadAllTemplates();
        } else {
          this.modalSvc.showToast(
            'Fehler beim Hochladen',
            'md-toast bg-red',
            'fas fa-exclamation'
          );
        }
        event.target.value = '';
      }
    );
  }
  deleteTemplate(node: any): void {
    if (!node.rtmIsEditable && !this.Data.defaultOE) {
      return;
    }

    this.modalSvc.showSimple(
      'Template löschen',
      'Möchten Sie dieses Template wirklich löschen?',
      true,
      true,
      'Ja, löschen',
      'Abbrechen'
    ).subscribe((response: boolean) => {
      if (response) {
        this.excRestService
          .delete(
            this.excRestService.computeUrl('ReportTemplateD', {
              oeID: this.Data.oeID,
              streamId: node.stream_id
            }),
            {}
          )
          .subscribe(
            (ret: any) => {
              if (ret.success) {
                this.modalSvc.showToast(
                  'Template gelöscht',
                  'md-toast bg-green',
                  'far fa-check'
                );
                this.loadAllTemplates();
              }
            }
          );
      }
    });
  }
  showTemplatePreview(node: any): void {
    if (node.is_directory) {
      return;
    }

    this.appSvc.Document.Preview.OpenModal({
      objID: this.Data.oeID,
      attID: node.stream_id,
      isTemplate: true,
      templateMime: node.file_type
    }, {Events: this.Events});
  }
  loadAllTemplates(): void {
    this.isLoadingTemplates = true;
    this.allTemplates = [];

    this.excRestService.post(
      this.excRestService.computeUrl('ReportTemplateStructure', { oeID: this.Data.oeID }),
      { parentPath: '' }
    ).subscribe((response: any) => {
      if (response?.success && response.data.length) {
        this.allTemplates = response.data;

        // Tree aufbauen
        this.ConfigTemplateTree.dataSource = this.buildTree(this.allTemplates);
        this.folderBySource.clear();

        // Alle Ordner im Tree sammeln
        const collectFolders = (nodes: any[]): void => {
          for (const f of nodes) {
            if (f && f.is_directory) {
              this.folderBySource.set(f.stream_id, f);
              if (f.children?.length) {
                collectFolders(f.children);
              }
            }
          }
        };
        collectFolders(this.ConfigTemplateTree.dataSource);

        // Alte offene Ordner wiederherstellen (ohne Events)
        const toExpand = (this.AttachmentFolderStates ?? [])
          .map(id => this.folderBySource.get(id))
          .filter(Boolean);

        if (this.AttachmentFolderStates.length === 0) {
          const expand = (nodes: any[], currentLevel: number = 0): any[] => {
            let result: any[] = [];
            for (const node of nodes) {
              if (node.is_directory && currentLevel < 2) {
                result.push(node);
                if (node.children?.length) {
                  result = result.concat(expand(node.children, currentLevel + 1));
                }
              }
            }
            return result;
          };

          const initialExpand = expand(this.ConfigTemplateTree.dataSource);
          this.ConfigTemplateTree.treeControl.expansionModel.select(...initialExpand);
        } else {
          this.ConfigTemplateTree.treeControl.expansionModel.select(...toExpand);
        }

        this.isLoadingTemplates = false;
        return;
      }

      // Fehlerfall
      this.modalSvc.showToast(
        'Es gab einen Fehler beim Abruf der Templates',
        'md-toast',
        'fas fa-exclamation'
      );
      this.isLoadingTemplates = false;
      this.ConfigTemplateTree.dataSource = [];
    });
  }

  getFileCount(node: any): number {
    if (!node.children || node.children.length === 0) {
      return 0;
    }
    return node.children.filter((child: any) => !child.is_directory).length;
  }

  toggleFolder(node: any, event: Event): void {
    if ((node.childCount || node.children?.length) > 0) {
      this.ConfigTemplateTree.treeControl.toggle(node);
    } else{
      event.stopPropagation();
    }
  }
  buildTree(hierarchyArray: any[]): any[] {
    const lookup: { [key: string]: any } = {};

    hierarchyArray.forEach(node => {
      lookup[node.path_locator_string] = {
        ...node,
        children: []
      };
    });

    const roots: any[] = [];

    hierarchyArray.forEach(node => {
      const treeNode = lookup[node.path_locator_string];

      if (node.parent_path_locator_string && lookup[node.parent_path_locator_string]){
        lookup[node.parent_path_locator_string].children.push(treeNode);
      } else
      {
        roots.push(treeNode);
      }
    });

    return roots;
  }
  pathClicked(node: any): void {
    if (!node.is_directory) {
      return;
    }

    for (const item of this.allTemplates){
      if (item.parent_path_locator_string === node.path_locator_string) {
        item.visible = !item.visible;
      } else if (item.parent_path_locator_string && item.parent_path_locator_string.includes(node.path_locator_string)) {
        item.visible = false;
      }
    }
  }
  loadChildren(parent: any): void {
    this.excRestService.post(
      this.excRestService.computeUrl('ReportTemplateStructure', { oeID: this.Data.oeID }),
      { parentPath: parent.path_locator_string }
    ).subscribe((response: any) => {
      if (response.success) {
        response.data.forEach((child: any) => {
          child.level = parent.level + 1;
          const parentIndex = this.allTemplates.indexOf(parent);
          this.allTemplates.splice(parentIndex + 1, 0, child);

          if (child.is_directory && child.childCount > 0) {
            this.loadChildren(child);
          }
        });
      }
    });
  }

  initLists(): void {
    const defaultValue = {
        enmName: 'OETyp',
        enmIdent: 0,
        enmText: '- nicht ausgewählt -',
        enmTextA: '',
        enmSelector: '',
        enmSort: -1,
        enmDefault: false,
        enmVFR: 1385460834987,
        enmVTO: 2305102434990
    };
    this.oeTypList = this.oeTypList.concat(defaultValue, this.enumService.getEnumerationList('OETyp'));


    defaultValue.enmName = 'AnredeTyp';
    this.oeAnredeList = this.oeAnredeList.concat(defaultValue, this.enumService.getEnumerationList('AnredeTyp'));

    defaultValue.enmName = 'CrmRolle' + (
      this.enumService.getEnumerationText(
        this.oeSummary.summary.OEDetails.oe_enmName_OETyp,
        this.oeSummary.summary.OEDetails.oe_enmIdent_OETyp
      ) === 'Person' ? 'Person' : 'Organisation');
    this.oeRolleList = this.oeRolleList.concat(
      defaultValue,
      this.enumService.getEnumerationList('CrmRolle' + (
        this.enumService.getEnumerationText(
          this.oeSummary.summary.OEDetails.oe_enmName_OETyp,
          this.oeSummary.summary.OEDetails.oe_enmIdent_OETyp
        ) === 'Person' ? 'Person' : 'Organisation')
      )
    );
  }

  updateOe(): void {
    if (this.appSvc.helperObj.changed(this.oeSummary.summary.OEDetails, this.oeSummary.summary.OEDetailsClone)) {
      this.excRestService
        .put(this.excRestService.computeUrl('OeU', {
          oeID: this.Data.oeID
        }), this.oeSummary.summary.OEDetailsClone)
        .subscribe((ret: any) => {
          if (ret.success) {
            this.modalSvc
              .showToast('Oe geupdated',
                'md-toast bg-green',
                'far fa-check');
          }
          this.oeSummary.loadData();
        });
      this.editMode = !this.editMode;
    }
  }

  cancelUpdate(): void {
    this.oeSummary.summary.OEDetailsClone = this.appSvc.helperObj.clone(this.oeSummary.summary.OEDetails);
    this.editMode = false;
  }

  openModalOeQuestionnaireComponent(config?: any): void {
    this.modalSvc.show('ModalOeQuestionnaireComponent', config)
      .subscribe((rtVal: any) => {
        if (rtVal) {
          if (rtVal?.del) {
            this.excRestService
              .delete(
                this.excRestService.computeUrl('OEQuestionnaireCUD', {
                  oeID: this.Data.oeID
                }), {
                  qcnfID: rtVal.qcnfID,
                  qcfgUPT: rtVal.qcfgUPT
                }
              )
              .subscribe((ret: any) => {
                if (ret.success) {
                  this.modalSvc
                    .showToast('Bericht gelöscht'
                      , 'md-toast bg-green'
                      , 'far fa-check');
                }
                this.oeSummary.loadData();
              });
          } else {
            const dataObject = {
              qcfgName: rtVal.qcfgName,
              qcfgIsDraft: rtVal.qcfgIsDraft
            };

            if (rtVal && rtVal.qcnfID) {
              Object.assign(
                dataObject, {
                  qcnfID: rtVal.qcnfID,
                  qcfgUPT: rtVal.qcfgUPT
                });
            }

            this.excRestService
              .post(this.excRestService.computeUrl('OEQuestionnaireCUD', {
                oeID: this.Data.oeID
              }), dataObject)
              .subscribe((ret: any) => {
                if (ret.success) {
                  if (rtVal.qcnfID) {
                    this.modalSvc
                      .showToast('Bericht geupdated',
                        'md-toast bg-green',
                        'far fa-check');
                  } else {
                    this.modalSvc
                      .showToast('Bericht erstellt',
                        'md-toast bg-green',
                        'far fa-check');
                  }
                }
                this.oeSummary.loadData();
              });
          }
        }
      });
  }

  openModalOeCalculationComponent(config?: any): void {
    this.modalSvc.show('ModalOeCalculationComponent', config)
      .subscribe((rtVal: any) => {
        if (rtVal) {
          if (rtVal?.del) {
            this.excRestService
              .delete(
                this.excRestService.computeUrl('OECalculationCUD', {
                  oeID: this.Data.oeID,
                }), {
                  ctID: rtVal.ctID,
                  ctUPT: rtVal.ctUPT
                }
              )
              .subscribe((ret: any) => {
                if (ret.success) {
                  this.modalSvc
                    .showToast('Kalkulation gelöscht'
                      , 'md-toast bg-green'
                      , 'far fa-check');
                }
                this.oeSummary.loadData();
              });
          } else {
            const dataObject = {
              ctName: rtVal.ctName,
              ctDescription: rtVal.ctDescription,
              ct_aue_enmIdent_Versicherungsart: rtVal.ct_aue_enmIdent_Versicherungsart,
              ct_enmIdent_DokTyp: rtVal.ct_enmIdent_DokTyp,
              ctIsDraft: rtVal.ctIsDraft
            };

            if (rtVal && rtVal.ctID) {
              Object.assign(
                dataObject, {
                  ctID: rtVal.ctID,
                  ctUPT: rtVal.ctUPT,
                });
            }

            this.excRestService
              .post(this.excRestService.computeUrl('OECalculationCUD', {
                oeID: this.Data.oeID
              }), dataObject)
              .subscribe((ret: any) => {
                if (ret.success) {
                  if (rtVal.ctID) {
                    this.modalSvc
                      .showToast('Kalkulation geupdated',
                        'md-toast bg-green',
                        'far fa-check');
                  } else {
                    this.modalSvc
                      .showToast('Kalkulation erstellt',
                        'md-toast bg-green',
                        'far fa-check');
                  }
                }
                this.oeSummary.loadData();
              });
          }
        }
      });
  }

  openModalOeFormularTemplateComponent(config?: any): void {
    this.modalSvc.show('ModalOEFormularTemplateComponent', config)
      .subscribe((rtVal: any) => {
        if (rtVal) {
          if (rtVal?.del) {
            this.excRestService
              .delete(
                this.excRestService.computeUrl('OEFormularTemplateCUD', {
                  oeID: this.Data.oeID,
                }), {
                  frmTID: rtVal.frmTID,
                  frmTUPT: rtVal.frmTUPT
                }
              )
              .subscribe((ret: any) => {
                if (ret.success) {
                  this.modalSvc
                    .showToast('Formular Template gelöscht'
                      , 'md-toast bg-green'
                      , 'far fa-check');
                }
                this.oeSummary.loadData();
              });
          } else {
            if (rtVal && rtVal.frmTID) {
              const dataObject = {
                frmTName: rtVal.frmTName,
                frmTDescription: rtVal.frmTDescription,
                frmT_aue_enmIdent_Versicherungsart: rtVal.frmT_aue_enmIdent_Versicherungsart,
                frmT_enmIdent_DokTyp: rtVal.frmT_enmIdent_DokTyp,
                frmTID: rtVal.frmTID,
                frmTUPT: rtVal.frmTUPT,
                frmTIsDraft: rtVal.frmTIsDraft
              };

              this.excRestService
                .put(this.excRestService.computeUrl('OEFormularTemplateCUD', {
                  oeID: this.Data.oeID
                }), dataObject)
                .subscribe((ret: any) => {
                  if (ret.success) {
                    this.modalSvc
                      .showToast('Formular Template geupdated',
                        'md-toast bg-green',
                        'far fa-check');
                  }
                  this.oeSummary.loadData();
                });
            } else {
              this.excRestService
                .post(this.excRestService.computeUrl('OEFormularTemplateCUD', {
                  oeID: this.Data.oeID
                }), rtVal.formData)
                .subscribe((ret: any) => {
                  if (ret.success) {
                    this.modalSvc
                      .showToast('Formular Template erstellt',
                        'md-toast bg-green',
                        'far fa-check');
                  }
                  this.oeSummary.loadData();
                });
            }
          }
        }
      });
  }

  openModalOeAddressComponent(data?: any): void {
    if (!data) {
      data = {new: true};
    } else {
      Object.assign(data, {new: false, showDelete: true});
    }

    this.modalSvc.show('ModalLocationCreateComponent', data)
      .subscribe((rtVal: any) => {
        if (rtVal) {
          if (rtVal?.del) {
            this.excRestService
              .delete(
                this.excRestService.computeUrl('OeAdresseCUD', {
                  oeID: this.Data.oeID
                }), {adrID: rtVal.adrID}
              )
              .subscribe((ret: any) => {
                if (ret.success) {
                  this.modalSvc
                    .showToast('Adresse gelöscht'
                      , 'md-toast bg-green'
                      , 'far fa-check');
                }
                this.oeSummary.loadData();
              });
          } else {
            const dataObject = {
                adr_enmIdent_AdresseTyp: rtVal.adr_enmIdent_AdresseTyp, // >= 0 ? rtVal.kont_enmIdent_KontaktTyp + 1 : -1,
                adrStr: rtVal.adrStr ? rtVal.adrStr : '',
                adrHNum: rtVal.adrHNum ? rtVal.adrHNum  : '',
                adrZusatz: rtVal.adrZusatz ? rtVal.adrZusatz  : '',
                adrPlz: rtVal.adrPlz ? rtVal.adrPlz  : '',
                adrOrt: rtVal.adrOrt ? rtVal.adrOrt  : '',
                adrBez: rtVal.adrBez ? rtVal.adrBez  : '',
                adrLkz: rtVal.adrLkz  ? rtVal.adrLkz : '',
                adrLat: rtVal.adrLat,
                adrLng: rtVal.adrLng,
            };

            if (rtVal && rtVal.adrID) {
              Object.assign(dataObject, {adrID: rtVal.adrID, adrUPT: rtVal.adrUPT});
            }

            this.excRestService
              .post(
                this.excRestService.computeUrl('OeAdresseCUD', {
                  oeID: this.Data.oeID
                }), dataObject
              )
              .subscribe((ret: any) => {
                if (ret.success) {
                  if (rtVal.adrID) {
                    this.modalSvc
                      .showToast('Adresse aktualisiert'
                        , 'md-toast bg-green'
                        , 'far fa-check');
                  } else {
                    this.modalSvc
                      .showToast('Adresse erstellt'
                        , 'md-toast bg-green'
                        , 'far fa-check');
                  }
                }
                this.oeSummary.loadData();
              });
          }
        }
      });
  }

  openModalOeContactComponent(data?: any): void {
    this.modalSvc.show('ModalOeContactComponent', data)
      .subscribe((rtVal: any) => {
        if (rtVal) {
          if (rtVal?.del) {
            this.excRestService
              .delete(this.excRestService.computeUrl('OeContactCUD', {
                oeID: this.Data.oeID
              }), {kontID: rtVal.kontID})
              .subscribe((ret: any) => {
                if (ret.success) {
                  this.modalSvc
                    .showToast('Kontakt gelöscht', 'md-toast bg-green', 'far fa-check');
                }
                this.oeSummary.loadData();
              });
          } else {
            const dataObject = {
              kont_enmIdent_KontaktTyp: rtVal.kont_enmIdent_KontaktTyp, // >= 0 ? rtVal.kont_enmIdent_KontaktTyp + 1 : -1,
              kontVal: rtVal.kontVal
            };

            if (rtVal && rtVal.kontID) {
              Object.assign(dataObject, {
                kontID: rtVal.kontID,
                kontUPT: rtVal.kontUPT,
              });
            }

            this.excRestService
              .post(this.excRestService.computeUrl('OeContactCUD', {
                oeID: this.Data.oeID
              }), dataObject)
              .subscribe((ret: any) => {
                if (ret && ret.success) {
                  if (rtVal.kontID) {
                    this.modalSvc
                      .showToast('Kontakt aktualisiert', 'md-toast bg-green', 'far fa-check');
                  } else {
                    this.modalSvc
                      .showToast('Kontakt erstellt', 'md-toast bg-green', 'far fa-check');
                  }
                  this.oeSummary.loadData();
                } else {
                  this.modalSvc
                    .showToast('Aktualisierung fehlgeschlagen', 'md-toast bg-red', 'far fa-cross');
                }
              });
          }
        }
      });
  }

  openModalOeList(): void {
    this.modalSvc
      .show('ModalOeListComponent', {})
      .subscribe((modalResponse: any) => {
        if (modalResponse && modalResponse.oeID) {
          this.excRestService
            .post(this.excRestService.computeUrl('OeMemberCUD', {
              parent_oeID: modalResponse.oeID,
              child_oeID: this.Data.oeID
            }), {})
            .subscribe((ret: any) => {
              if (ret && ret.success) {
                this.modalSvc
                  .showToast('Mitglied hinzugefügt', 'md-toast bg-green', 'far fa-check');
              } else {
                this.modalSvc
                  .showToast('Fehler beim hinzufügen', 'md-toast bg-red', 'far fa-check');
              }
              this.oeSummary.loadData();
            });
        }
    });
  }

  openModalGroupList(): void {
    this.modalSvc
      .show('ModalOeGroupListComponent', {})
      .subscribe((modalResponse: any) => {
        if (modalResponse && modalResponse.grpID) {
          this.excRestService
            .post(this.excRestService.computeUrl('OeGroupCUD', {
              oeID: this.Data.oeID,
              grpID: modalResponse.grpID
            }), {})
            .subscribe((ret: any) => {
              if (ret && ret.success) {
                this.modalSvc
                  .showToast('Gruppe hinzugefügt', 'md-toast bg-green', 'far fa-check');
              } else {
                this.modalSvc
                  .showToast('Fehler beim hinzufügen', 'md-toast bg-red', 'far fa-check');
              }
              this.oeSummary.loadData();
            });
        }
    });
  }

  removeGroup(grp: any): void {
    this.modalSvc.showSimple(
      this.getRessource('removeGroup.Title'),
      this.getRessource('removeGroup.Message'),
      true,
      true,
      this.getRessource('removeGroup.ButtonText'),
      this.getGlobal('Cancel'),
    ).subscribe((rtVal: boolean) => {
      if (rtVal) {
        this.excRestService
          .delete(this.excRestService.computeUrl('OeGroupCUD', {
            oeID: this.Data.oeID,
            grpID: grp.grpID
          }), {})
          .subscribe((ret: any) => {
            if (ret && ret.success) {
              this.modalSvc
                .showToast('Gruppe entfernt', 'md-toast bg-green', 'far fa-check');
            }
            this.oeSummary.loadData();
          });
      }
    });

  }

  removeOeParentChildRelation(parentOEID: any, childOEID: any): void {
    this.modalSvc.showSimple(
      this.getRessource('removeOeParentChildRelation.Title'),
      this.getRessource('removeOeParentChildRelation.Message'),
      true,
      true,
      this.getRessource('removeOeParentChildRelation.ButtonText'),
      this.getGlobal('Cancel'),
    ).subscribe((rtVal: boolean) => {
      if (rtVal) {
        this.excRestService
          .delete(this.excRestService.computeUrl('OeMemberCUD', {
            parent_oeID: parentOEID,
            child_oeID: childOEID
          }), {})
          .subscribe((ret: any) => {
            if (ret && ret.success) {
              this.modalSvc
                .showToast('Verknüpfung entfernt', 'md-toast bg-green', 'far fa-check');
            }
            this.oeSummary.loadData();
          });
      }
    });
  }

  openOEWorkspaceTab(oeID?: number): void {
    this.appSvc.OE.Workspace.OpenTab(
      oeID
    );
  }

  openCalculationTemplate(row?: any): void {
    if (row) {
      const data = {ctID: row.ctID, oeID: this.Data.oeID, Events: this.Events};
      const tab = new ExgApplicationTab(row.ctName, CalculationTemplateComponent, data, data.ctID);
      tab.Open();
    }
  }

  openQuestionnairTemplate(row?: any): void {
    if (row) {
      const data = {qcnfID: row.qcnfID};
      const tab = new ExgApplicationTab(row.qcfgName, QuestionnaireEditorComponent, data, data.qcnfID);
      tab.Open();
    }
  }

  openFormularTemplate(row?: any): void {
    if (row) {
      const data = {frmTID: row.frmTID, Events: this.Events};
      const tab = new ExgApplicationTab(row.frmTName, FormularTemplateComponent, data, data.frmTID);
      tab.Open();
    }
  }

  uploadLogo(): void {
    document.getElementById('logo-upload')?.click();
  }

  onLogoSelected(event: Event): void {
    const file = (event.target as HTMLInputElement).files?.[0];
    if (!file?.type.startsWith('image/')) {
      if (file) {
        this.modalSvc.showToast(
          'Nur Bilddateien erlaubt',
          'md-toast bg-red',
          'fas fa-exclamation'); }
      return;
    }

    const img = new Image();
    img.onload = () => {
      const canvas = document.createElement('canvas');
      const maxSize = 200;
      let width = img.width;
      let height = img.height;

      if (width > height && width > maxSize) {
        height = (height * maxSize) / width;
        width = maxSize;
      } else if (height > maxSize) {
        width = (width * maxSize) / height;
        height = maxSize;
      }

      canvas.width = width;
      canvas.height = height;
      canvas.getContext('2d')?.drawImage(img, 0, 0, width, height);

      const dataUrl = canvas.toDataURL('image/png');
      this.oeSummary.summary.OEDetails.oeLogo = dataUrl;

      canvas.toBlob((blob) => {
        if (blob) {
          const formData = new FormData();
          formData.append('file', blob, 'logo.png');
          this.excRestService
            .post(this.excRestService.computeUrl('OeLogoC', {oeID: this.Data.oeID}), formData)
            .subscribe((ret: any) => {
              if (ret?.success) {
                this.modalSvc.showToast(
                  'Logo hochgeladen',
                  'md-toast bg-green',
                  'far fa-check');
              }
            });
        }
      }, 'image/png');
    };

    img.src = URL.createObjectURL(file);
    (event.target as HTMLInputElement).value = '';
  }
}
